"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
/* eslint-disable */
var react_1 = __importStar(require("react"));
var semantic_ui_react_1 = require("semantic-ui-react");
var react_router_dom_1 = require("react-router-dom");
var react_redux_1 = require("react-redux");
var react_router_1 = require("react-router");
var actions = __importStar(require("./signUpActions"));
var ActivationKeyStage_1 = __importDefault(require("./components/ActivationKeyStage"));
var EmailAndPasswordStage_1 = __importDefault(require("./components/EmailAndPasswordStage"));
var SuccessfulActivationStage_1 = __importDefault(require("./components/SuccessfulActivationStage"));
var signup_module_scss_1 = __importDefault(require("./signup.module.scss"));
var SignUp = /** @class */ (function (_super) {
    __extends(SignUp, _super);
    function SignUp() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            username: '',
            email: '',
            display_name: '',
            password: '',
            refId: '',
            checked: false
        };
        _this.handleChange = function (e, _a) {
            var _b;
            var name = _a.name, value = _a.value;
            return _this.setState((_b = {}, _b[name] = value, _b));
        };
        _this.handleCheckbox = function (e, _a) {
            var checked = _a.checked;
            return _this.setState({ checked: checked });
        };
        _this.handleSubmit = function () {
            var _a = _this.state, username = _a.username, email = _a.email, password = _a.password, checked = _a.checked;
            var signUp = _this.props.signUp;
            if (checked) {
                signUp({ first_name: username, email: email, password: password });
            }
        };
        return _this;
    }
    SignUp.prototype.componentDidMount = function () {
        var queryParameters = new URLSearchParams(window.location.search);
        var token = queryParameters.get("token");
        var history = this.props.history;
        var page = window.location.pathname.split("/")[2];
        console.log(page);
        if (token && !page) {
            history.push("/signup/activation?token=".concat(token));
        }
    };
    SignUp.prototype.componentDidUpdate = function (prevProps) {
        var _a = this.props, signUpStatus = _a.signUpStatus, history = _a.history;
        if (signUpStatus !== prevProps.signUpStatus) {
            switch (signUpStatus) {
                case 'initial':
                    break;
                case 'success':
                    history.push('/sign-up/success');
                    break;
                case 'activation_key':
                    history.push('/sign-up/activation');
                    break;
                default:
                    break;
            }
        }
    };
    SignUp.prototype.render = function () {
        var signUpStatus = this.props.signUpStatus;
        console.log(signUpStatus);
        return ((0, jsx_runtime_1.jsx)("div", __assign({ className: signup_module_scss_1.default.signup }, { children: (0, jsx_runtime_1.jsx)(semantic_ui_react_1.Container, { children: signUpStatus !== 'loading' ? ((0, jsx_runtime_1.jsxs)(react_router_1.Switch, { children: [(0, jsx_runtime_1.jsx)(react_router_1.Route, { exact: true, path: "/signup", component: EmailAndPasswordStage_1.default }), (0, jsx_runtime_1.jsx)(react_router_1.Route, { path: "/signup/success", component: SuccessfulActivationStage_1.default }), (0, jsx_runtime_1.jsx)(react_router_1.Route, { path: "/signup/activation", component: ActivationKeyStage_1.default })] })) : ((0, jsx_runtime_1.jsx)(semantic_ui_react_1.Loader, { active: true })) }) })));
    };
    return SignUp;
}(react_1.Component));
exports.default = (0, react_router_dom_1.withRouter)((0, react_redux_1.connect)(function (state) {
    return {
        signUpFetching: state.signUp.signUpFetching,
        signUpStatus: state.signUp.signUpStatus
    };
}, function (dispatch) { return ({
    signUp: function (params) {
        dispatch(actions.signUp(params));
    }
}); })(SignUp));
